const getDefaultState = () => {
  return {};
};

const state = getDefaultState();

const getters = {
  getVacanciesForSelect: (state, getters, rootState, rootGetters) => {
    return rootGetters['vacancies/getActiveVacancies'].map(x => {
      return { value: x.id, text: x.name };
    });
  }
};

export default {
  namespaced: true,
  state,
  getters
};
